import AgreementsSection from "@/components/agreements-section";
import SeoMeta from "@/components/seo-meta";
import data from "@/data/setup.json";
import { buildMedicalBusinessJsonLd } from "@/lib/seo-data";

export default function AgreementsPage() {
	return (
		<>
			<SeoMeta
				title={`Convênios e Parceiros | ${data.cliente.nome}`}
				description={data["area-convenios"].texto}
				canonicalPath="/convenios"
				jsonLd={buildMedicalBusinessJsonLd(data)}
			/>
			<AgreementsSection data={data} />
		</>
	);
}
